import { render, staticRenderFns } from "./Refund.vue?vue&type=template&id=6568c056&scoped=true"
import script from "./Refund.vue?vue&type=script&lang=js"
export * from "./Refund.vue?vue&type=script&lang=js"
import style0 from "./Refund.vue?vue&type=style&index=0&id=6568c056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6568c056",
  null
  
)

export default component.exports